export class Handover {
  id: string = "00000000-0000-0000-0000-000000000000";
  createdBy: string = "00000000-0000-0000-0000-000000000000";
  handoverTo?: string = "";
  location: string = "00000000-0000-0000-0000-000000000000";
  position: string = "00000000-0000-0000-0000-000000000000";
  creatorNote: string = "";
  receiverNote: string = "";
  state: number = 0;
  createdTimeString: Date = new Date();
}

export class HandoverCandidate {
  id: string = "";
  fullName: string = "";
  activelyAssigned: boolean = false;
  lastAssignment?: Date;
  alreadyRequested: boolean = false;
}